export const formatDateTime = (isoString: string) => {
  if (Number.isNaN(Date.parse(isoString))) return isoString;
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  };
  return new Date(isoString).toLocaleString('fr-FR', options).replace(',', '');
};

export const formatDateToYYYYMMDD = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDateToDDMMYY = (date: Date): string => {
  const year = date.getFullYear().toString().slice(-2);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${day}/${month}/${year}`;
};

export const getNextDayFormatted = (date: Date): string => {
  const nextDay = new Date(date);
  nextDay.setDate(date.getDate() + 1);
  return formatDateToYYYYMMDD(nextDay);
};

export function getMonday(d: Date) {
  d = new Date(d);
  const day = d.getDay(),
    diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return new Date(d.setDate(diff));
}
